import { render, staticRenderFns } from "./firstDetail.vue?vue&type=template&id=41fbad7c&scoped=true"
import script from "./firstDetail.vue?vue&type=script&lang=js"
export * from "./firstDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fbad7c",
  null
  
)

export default component.exports